import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

export const RequestOtpInputSchema = z.object({
  email: z.string().email('Ogiltig e-post'),
});

export type RequestOtpInput = z.infer<typeof RequestOtpInputSchema>;

export type RequestOtpResult = {
  authenticationId: string;
};

export const requestOtp = async ({ data }: { data: RequestOtpInput }): Promise<RequestOtpResult> => {
  return (await api.post(`/auth/login/otp/request`, data)).data;
};

type UseRequestOtpOptions = {
  mutationConfig?: MutationConfig<typeof requestOtp>;
};

export const useRequestOtp = ({ mutationConfig }: UseRequestOtpOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: requestOtp,
  });
};
